export default "__VITE_ASSET__DnddT9ut__"